<template>
  <div class="d-flex px-2 py-1" :class="containerClass" :style="styleCss" @click="onClick">
    <slot>
      <b-col>
        <div class="h-100 d-flex justify-content-between flex-column">
          <b-row>
            <b-col class="px-1 label" :class="labelClass">{{ label }}</b-col>
          </b-row>
          <b-row>
            <b-col class="px-1 value">{{ value }}</b-col>
          </b-row>
        </div>
      </b-col>
      <div class="ml-auto align-self-center" v-if="icon">
        <slot name="icon"><custom-icon :icon="icon" :css-class="iconClass" /></slot>
      </div>
      <div class="ml-auto align-self-center" v-if="checkbox">
        <slot name="checkbox">
          <b-form-checkbox :value="checkboxValue"
                           v-model="toggleData"
          ></b-form-checkbox>
        </slot>
      </div>
    </slot>
  </div>

</template>

<script>
import CustomIcon from '@/components/Custom/CustomIcon';
import StatMixin from '@/components/Dashboard/StatMixin';
import { cloneDeep } from 'lodash';

export default {
  name: 'StatTile',
  components: {
    CustomIcon,
  },
  mixins: [StatMixin],
  props: {
    iconClass: {
      type: String,
    },
    labelClass: {
      type: String,
    },
    checkbox: {
      type: Boolean,
      default: false,
    },
    checkboxModel: {
      type: Array,
    },
    checkboxValue: {
      type: String,
    },
  },
  computed: {
    containerClass() {
      let cssClass = (this.clickable || this.to) ? 'cursor-pointer' : '';

      if (this.cssClass) {
        if (cssClass) {
          cssClass = cssClass + ' ';
        }
        cssClass = cssClass + this.cssClass;
      }

      return cssClass;
    },
    styleCss() {
      let style = '';
      if (this.color) {
        style = 'color: ' + this.color + ';';
      }

      if (this.bgColor) {
        style = style + 'background: ' + this.bgColor + ';';
      }

      return style;
    },
    labelCss() {
      if (!this.labelColor) {
        return '';
      }
      return 'color: ' + this.labelColor;
    },
  },
  data() {
    return {
      toggleData: [],
    }
  },
  mounted() {
    this.toggleData = cloneDeep(this.checkboxModel);
  },
  watch: {
    checkboxModel: {
      handler(newValue) {
        this.toggleData = newValue;
      },
      immediate: true,
    },
    toggleData: {
      handler(newValue) {
        this.$emit('checkbox:changed', newValue);
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
  .label {
    font-size: 8px;
  }
  .label-medium {
    font-size: 9px;
  }
  .label-large {
    font-size: 10px;
  }
  .value {
    font-size: 18px;
    line-height: 18px;
    font-weight: bolder;
  }
  .text-black {
    color: #000000;
  }
</style>
